<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <modal-editor :config="{ id: gridConfig.id, api: 'Contents/Get/' }"/>
  </div>
</template>
<script>
import gridConfig from './GridConfig'

export default {
  name: 'ContentsIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-editor': () => import(/* webpackChunkName: 'Contents' */ './Editor')
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  }
}
</script>
